export default "__VITE_ASSET__BHxUmpwF__"